<template>
  <v-container>
    <h2 class="ccm-title">
      Ce que je reçois avec cette offre ?
    </h2>

    <v-layout row wrap align-top>
      
      <v-flex xs12 sm6 md3>
        <v-card
          class="ma-2 pa-2"
          max-width="344"
          flat
          style="background-color: transparent"
        >
          <v-img
            src="/gimc/storage/assets/card/todo_1.png?height=150&format=jpeg"
            lazy-src="/gimc/storage/assets/card/todo_1.png?thumb=true"
            height="150px"
            contain
          ></v-img>

          <v-card-text class="ccm-text" v-html="homeData.todo.tile1.description"></v-card-text>

        </v-card>
      </v-flex>

      <v-flex xs12 sm6 md3>
        <v-card
          class="ma-2 pa-2"
          max-width="344"
          flat
          style="background-color: transparent"
        >
          <v-img
            src="/gimc/storage/assets/card/todo_2.png?height=150&format=jpeg"
            lazy-src="/gimc/storage/assets/card/todo_2.png?thumb=true"
            height="150px"
            contain
          ></v-img>

          <v-card-text class="ccm-text" v-html="homeData.todo.tile2.description"></v-card-text>
        </v-card>
      </v-flex>

      <v-flex xs12 sm6 md3>
        <v-card
          class="ma-2 pa-2"
          max-width="344"
          flat
          style="background-color: transparent"
        >
          <v-img
            src="/gimc/storage/assets/card/todo_3.png?height=150&format=jpeg"
            lazy-src="/gimc/storage/assets/card/todo_3.png?thumb=true"
            height="150px"
            contain
          ></v-img>

          <v-card-text class="ccm-text" v-html="homeData.todo.tile3.description"></v-card-text>
        </v-card>
      </v-flex>

      <v-flex xs12 sm6 md3>
        <v-card
          class="ma-2 pa-2"
          max-width="344"
          flat
          style="background-color: transparent"
        >
          <v-img
            src="/gimc/storage/assets/card/todo_4.png?height=150&format=jpeg"
            lazy-src="/gimc/storage/assets/card/todo_4.png?thumb=true"
            height="150px"
            contain
          ></v-img>

          <v-card-text class="ccm-text" v-html="homeData.todo.tile4.description"></v-card-text>
        </v-card>
      </v-flex>


    </v-layout>

  </v-container>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  data: () => ({
    baseUrl: process.env.VUE_APP_BASE_URL || '',
  }),
  computed: {
    ...mapGetters('strapi', ['livrable']),
    ...mapGetters('app', ['homeData'])
  }
}
</script>

<style scoped>
.ccm-title {
  /* color:#0b755f; */
  /* font-size: 2em; */
  text-align:center;
  padding-bottom: 1em;
}

.ccm-text {
  font-size: 16px;
  text-align: center;
  word-break:normal
}
</style>